import React, { useEffect, useMemo, useRef, useState } from "react";
import Header from "../../sharedScreens/Header";
import FlightListHeader from "../../components/composite/FlightListHeader";
import FlightListFilterCard from "../../components/composite/FlightListFilterCard";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import { airlines, flightOptions, List } from "../../constants/constant";
import { FormikValues, useFormik } from "formik";
import { FlightSearchModel } from "../../model/FlightSearchModel";
import { flightSearchSchema } from "../../validations/Schema";
import { UtilService } from "../../services/shared/UtilService";
import { msgTypes } from "../../constants/msgTypes";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import MuiRadioButton from "../../components/basicComponent/MuiRAdioButton";
import MuiButton from "../../components/basicComponent/MuiButton";
import FlightListMainCard from "../../components/composite/FlightListMainCard";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {
  Airport,
  CommissionValue,
  Filters,
  FlightListData,
  PopularFilterOption,
  Segments,
} from "../../constants/types";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import { Box, Modal, Typography } from "@mui/material";
import Calendar from "../../components/basicComponent/Calender";
import { formatDate } from "../../constants/helper";
import CalendarSlider from "../../components/composite/CalendarSlider";
import { FlightServices } from "../../services/FlightServices/FlightServices";
import { useAlert } from "../../services/customHooks/useAlert";
import { useGlobalState } from "../../services/context/AuthContext";
import { useFlightSearch } from "../../services/context/FlightSearchContext";
import { number } from "yup";
import FlightRoundTripCard from "@/components/composite/FlightRoundTripCard";
import FlightRoundTripList from "./IntlRTFLightListCard";
import IntlRTFLightListCard from "./IntlRTFLightListCard";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";

const FlightList: React.FC = () => {
  const { showAlert } = useAlert();
  const { userInfo, setCommissionRules } = useGlobalState();
  const location = useLocation();
  const [traceId, setTraceId] = useState<string>("");
  const [airportList, setAirportList] = useState<List[]>([]);
  const [showCalender, setShowCalender] = useState<boolean>(false);
  const [calenderMonthWiseData, setCalenderMonthWiseData] = useState<any[]>([]);
  const [calenderData, setCalenderData] = useState([]);

  const [ruleId, setRuleId] = useState<string>("");
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [originalFlightData, setOriginalFlightData] = useState<
    FlightListData[] | null
  >(null);
  const [filteredFlightData, setFilteredFlightData] = useState<
    FlightListData[] | null
  >(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [tripType, setTripType] = useState<number>(0);
  const origin =
    filteredFlightData?.[0]?.Segments?.[0]?.Bonds?.[0]?.Legs?.[0]?.Origin;
  const destination =
    filteredFlightData?.[0]?.Segments?.[0]?.Bonds?.[0]?.Legs?.[0]?.Destination;
  // Update to handle data as an array
  const allFares = originalFlightData?.flatMap(
    (journey) =>
      journey.Segments?.map((segment) => segment.Fare.TotalFareWithOutMarkUp) ||
      []
  );
  const totalPassengers =
    filteredFlightData?.[0]?.Segments?.[0]?.Fare?.PaxFares?.length || 0;

  const [filters, setFilters] = useState<Filters>({
    airlines: {},
    priceRange: {
      min: 0,
      max: 0,
      value: [0, 0],
    },
    stops: {
      nonstop: false,
      oneStop: false,
      twoOrMoreStops: false,
    },
    departureTime: {
      before6AM: false,
      from6AMto12PM: false,
      from12PMto6PM: false,
      after6PM: false,
    },
    arrivalTime: {
      before6AM: false,
      from6AMto12PM: false,
      from12PMto6PM: false,
      after6PM: false,
    },
    flightQuality: {
      wifi: false,
      redEye: false,
    },
  });

  // Function to update fare values
  const updateFare = () => {
    if (Array.isArray(allFares) && allFares.length > 0) {
      const highestFare = Math.max(...allFares);
      const smallestFare = Math.min(...allFares);

      // Prevent unnecessary updates
      if (
        filters.priceRange.min !== smallestFare ||
        filters.priceRange.max !== highestFare
      ) {
        setFilters((prev) => ({
          ...prev,
          priceRange: {
            min: smallestFare,
            max: highestFare,
            value: [smallestFare, highestFare],
          },
        }));
      }
    } else {
      // Prevent unnecessary updates
      if (filters.priceRange.min !== 0 || filters.priceRange.max !== 0) {
        setFilters((prev) => ({
          ...prev,
          priceRange: {
            min: 0,
            max: 0,
            value: [0, 0],
          },
        }));
      }
    }
  };

  // Run `updateFare` when `allFares` changes
  useEffect(() => {
    updateFare();
  }, [allFares]); // Only runs when `allFares` changes

  const storedSearch = localStorage.getItem("flight_recent_search");
  const data = storedSearch
    ? JSON.parse(storedSearch)
    : location.state?.values || {};

  const formik = useFormik({
    initialValues: new FlightSearchModel(data),
    enableReinitialize: true,
    validationSchema: flightSearchSchema,
    onSubmit(values, formikHelpers) {
      console.log("values", values);
      flightListData(values);
    },
  });
  const [swapOrigin, setSwapOrigin] = useState<string>(formik.values.origin);
  const [swapOriginCode, setSwapOriginCode] = useState<string>(
    formik.values.originCode
  );
  const [swapDestination, setSwapDestination] = useState<string>(
    formik.values.destination
  );
  const [swapDestinationCode, setSwapDestinationCode] = useState<string>(
    formik.values.destinationCode
  );

  useEffect(() => {
    setSwapOrigin(formik.values.origin);
    setSwapOriginCode(formik.values.originCode);
    setSwapDestination(formik.values.destination);
    setSwapDestinationCode(formik.values.destinationCode);
  }, []);

  const [rotated, setRotated] = useState(false);
  const handleSwap = () => {
    setSwapOrigin((prev) => {
      const temp = swapDestination;
      setSwapDestination(prev);
      return temp;
    });
    setSwapOriginCode((prev) => {
      const temp = swapDestinationCode;
      setSwapDestinationCode(prev);
      return temp;
    });
    setRotated(!rotated);
  };

  // Handle filter changes from FlightListFilterCard
  const handleFilterChange = (newFilters: Filters): void => {
    setFilters(newFilters);

    // Apply the new filters to the original data
    const newFilteredData = applyFilters(originalFlightData, newFilters);
    setFilteredFlightData(newFilteredData);
  };

  // Updated to handle array of FlightListData
  const applyFilters = (
    data: FlightListData[] | null,
    filters: Filters
  ): FlightListData[] | null => {
    if (!data || data.length === 0) return null;

    const filteredData = JSON.parse(JSON.stringify(data));

    return filteredData.map((journey: FlightListData) => {
      if (!journey.Segments) return journey;

      let filteredSegments = [...journey.Segments];

      // Stops Filter
      const stopsSelected =
        filters.stops.nonstop ||
        filters.stops.oneStop ||
        filters.stops.twoOrMoreStops;
      if (stopsSelected) {
        filteredSegments = filteredSegments.filter((segment: Segments) => {
          const bonds = segment.Bonds || [];

          // Must match all bonds (OutBound + InBound)
          return bonds.every((bond) => {
            const legs = bond.Legs || [];
            const numberOfStops = Math.max(legs.length - 1, 0);

            // Match based on user's filter
            return (
              (filters.stops.nonstop && numberOfStops === 0) ||
              (filters.stops.oneStop && numberOfStops === 1) ||
              (filters.stops.twoOrMoreStops && numberOfStops >= 2)
            );
          });
        });
      }

      // Airline Filter
      const airlineFiltersSelected = Object.values(filters.airlines).some(
        (val) => val === true
      );

      if (airlineFiltersSelected) {
        filteredSegments = filteredSegments.filter((segment: Segments) => {
          const allLegs =
            segment.Bonds?.flatMap((bond) => bond.Legs || []) || [];

          return allLegs.some((leg) => {
            const airlineKey = leg.FlightName.toLowerCase().replace(/\s/g, "");
            return filters.airlines[airlineKey] === true;
          });
        });
      }

      // Departure Time Filter
      const departureTimeSelected =
        filters.departureTime.before6AM ||
        filters.departureTime.from6AMto12PM ||
        filters.departureTime.from12PMto6PM ||
        filters.departureTime.after6PM;

      if (departureTimeSelected) {
        filteredSegments = filteredSegments.filter((segment: Segments) => {
          const allLegs =
            segment.Bonds?.flatMap((bond) => bond.Legs || []) || [];

          return allLegs.some((leg) => {
            const hour = parseInt(leg.DepartureTime.split(":")[0], 10);
            return (
              (filters.departureTime.before6AM && hour < 6) ||
              (filters.departureTime.from6AMto12PM && hour >= 6 && hour < 12) ||
              (filters.departureTime.from12PMto6PM &&
                hour >= 12 &&
                hour < 18) ||
              (filters.departureTime.after6PM && hour >= 18)
            );
          });
        });
      }

      // Arrival Time Filter
      const arrivalTimeSelected =
        filters.arrivalTime.before6AM ||
        filters.arrivalTime.from6AMto12PM ||
        filters.arrivalTime.from12PMto6PM ||
        filters.arrivalTime.after6PM;

      if (arrivalTimeSelected) {
        filteredSegments = filteredSegments.filter((segment: Segments) => {
          const allLegs =
            segment.Bonds?.flatMap((bond) => bond.Legs || []) || [];

          return allLegs.some((leg) => {
            const hour = parseInt(leg.ArrivalTime.split(":")[0], 10);
            return (
              (filters.arrivalTime.before6AM && hour < 6) ||
              (filters.arrivalTime.from6AMto12PM && hour >= 6 && hour < 12) ||
              (filters.arrivalTime.from12PMto6PM && hour >= 12 && hour < 18) ||
              (filters.arrivalTime.after6PM && hour >= 18)
            );
          });
        });
      }

      // Price Filter
      filteredSegments = filteredSegments.filter((segment: Segments) => {
        return (
          segment.Fare &&
          segment.Fare.TotalFareWithOutMarkUp >= filters.priceRange.value[0] &&
          segment.Fare.TotalFareWithOutMarkUp <= filters.priceRange.value[1]
        );
      });

      return { ...journey, Segments: filteredSegments };
    });
  };

  useEffect(() => {
    getAirportList();
    getCalenderData();
  }, []);

  useEffect(() => {
    if (!!data) {
      flightListData(data);
    }
  }, []);

  const getAirportList = async (): Promise<void> => {
    try {
      const response = await UtilService.getAirport();

      if (response.statusMsg === msgTypes.SUCCESS.msg) {
        const arr = response?.data?.map((i: Airport) => ({
          label: i?.airportName + " (" + i?.airportCode + ")",
          value: i?.airportName,
          code: i?.airportCode,
        }));

        setAirportList(arr);
      }
    } catch (error) {
      console.error("Error fetching airport list:", error);
    }
  };
  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    formik.setFieldValue("travelClass", e.target.value);
    if (e.target.value === "Economy") {
      formik.setFieldValue("cabin", 0);
    } else if (e.target.value === "Premium Economy") {
      formik.setFieldValue("cabin", 4);
    } else if (e.target.value === "Business") {
      formik.setFieldValue("cabin", 2);
    } else if (e.target.value === "First Class") {
      formik.setFieldValue("cabin", 1);
    }
  };

  const openPopup = (): void => {
    setIsPopupOpen(true);
  };

  const closePopup = (): void => {
    setIsPopupOpen(false);
  };

  const handleDone = (): void => {
    const travellers: number =
      formik.values.adults + formik.values.child + formik.values.infants;
    const travellersDetail: string = `${travellers} Travellers - ${formik.values.travelClass}`;
    formik.setFieldValue("travellersDetail", travellersDetail);
    setIsPopupOpen(false);
  };

  const getCabinValue = () => {
    if (formik.values.cabin === 0) {
      return "Economy";
    } else if (formik.values.cabin === 1) {
      return "First Class";
    } else if (formik.values.cabin === 2) {
      return "Business";
    } else if (formik.values.cabin === 4) {
      return "Premium Economy";
    } else return "Economy";
  };

  const getCalenderData = async () => {
    const currentMonth = new Date().getMonth() + 1;
    const payload = {
      Date: formik.values.fromDate,
      Destination: formik.values.destinationCode,
      Months: 3,
      Origin: formik.values.originCode,
    };

    try {
      const data = await FlightServices.getFlightRateAccToDate(payload);
      setCalenderData(data?.data?.lstMonths);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset to midnight

      const sortedData = data?.data?.lstMonths?.map((month: any) => {
        const futureDatesOnly = month.lstCalFare.filter((fare: any) => {
          const depDate = new Date(fare.DepDate);
          return depDate >= today;
        });

        // Sort by departure date
        const sorted = futureDatesOnly.sort(
          (a: any, b: any) =>
            new Date(a.DepDate).getTime() - new Date(b.DepDate).getTime()
        );

        return sorted;
      });
      setCalenderMonthWiseData(sortedData);
    } catch (error) {
      console.log("error while getting flight search data", error);
    }
  };
  const flightListData = async (payload: FormikValues): Promise<void> => {
    setLoading(true);

    // Initialize FlightSearchDetails array with the outbound trip
    const flightSearchDetails = [
      {
        BeginDate: payload?.fromDate,
        CurrencyCode: payload?.currencyCode,
        Origin: payload?.originCode,
        Destination: payload?.destinationCode,
      },
    ];

    // Add return trip details if it's a round trip
    if (payload?.tripTypeNumber === 1) {
      // Assuming 2 represents a round trip
      flightSearchDetails.push({
        BeginDate: payload?.toDate, // Return date
        CurrencyCode: payload?.currencyCode,
        Origin: payload?.destinationCode, // Swap origin and destination for the return trip
        Destination: payload?.originCode,
      });
    }

    const requestBody = {
      Adults: payload?.adults,
      Cabin: payload?.cabin,
      Childs: payload?.child,
      FlightSearchDetails: flightSearchDetails, // Use the dynamically constructed array
      Infants: payload?.infants,
      TripType: payload?.tripTypeNumber,
    };

    try {
      const response = await FlightServices.getFlightList(requestBody);
      // Changed to use the full Journeys array
      if (response?.data?.Journeys !== null) {
        if (!!userInfo?.corporate_id) {
          getFlightCommissionValue();
        }
        const fetchedData = response?.data?.Journeys;
        setTripType(payload.tripTypeNumber);
        // Store the original data
        setOriginalFlightData(fetchedData);
        setTraceId(response?.data?.TraceId);
        // Set filtered data initially to the original data
        setFilteredFlightData(fetchedData);

        // Get airlines list by processing all journeys
        const airlines = extractAirlinesFromFlightData(fetchedData);

        // Update the airlines in filters separately
        const newAirlineFilters: { [key: string]: boolean } = {};
        airlines.forEach((airline) => {
          newAirlineFilters[airline.key] =
            filters.airlines[airline.key] || false;
        });

        setFilters((prev) => ({
          ...prev,
          airlines: newAirlineFilters,
        }));
        // setLoading(false);
        getCalenderData();
        setLoading(false);
      } else if (!!response.data.Errors?.Description) {
        showAlert({
          title: "Error",
          text: response.data.Errors?.Description,
          icon: "error",
        });
      }
    } catch (error: any) {
      showAlert({
        title: "Error",
        text: error?.message ?? "Something went wrong. Please try again.",
        icon: "error",
      });
      console.log("error while getting flight search data", error);
      setLoading(false);
    }
  };

  // Updated to handle array of FlightListData
  const extractAirlinesFromFlightData = (
    data: FlightListData[] | null
  ): PopularFilterOption[] => {
    if (!data || data.length === 0) {
      return [
        { key: "airindia", label: "Air India" },
        { key: "indigo", label: "IndiGo" },
        { key: "spicejet", label: "SpiceJet" },
        { key: "vistara", label: "Vistara" },
      ]; // Default airlines
    }

    // Extract unique airline names from all journeys
    const airlineNames = new Set<string>();

    data.forEach((journey) => {
      journey.Segments?.forEach((segment: Segments) => {
        const airlineName = segment.Bonds?.[0]?.Legs?.[0]?.FlightName;
        if (airlineName) {
          airlineNames.add(airlineName);
        }
      });
    });

    const airlinesOptions: PopularFilterOption[] = Array.from(airlineNames).map(
      (airline) => ({
        key: airline.toLowerCase().replace(/\s/g, ""),
        label: airline,
      })
    );

    return airlinesOptions;
  };

  const travellersDetail = {
    adultCount: formik.values.adults,
    childrenCount: formik.values.child,
    infantCount: formik.values.infants,
  };
  const isInternationalFlight = !!filteredFlightData?.[0]?.Segments?.[0]
    ?.IsInternational
    ? filteredFlightData?.[0]?.Segments?.[0]?.IsInternational
    : false;

  const getFlightCommissionValue = async () => {
    const id = Number(userInfo?.category?.flightCategory);

    try {
      // const response = await UtilService.getFlightCommissionData(id);
      // console.log("response", response);
      const response = await UtilService.tempcategory(id);
      setCommissionRules(response?.data ?? []);
    } catch (error) {
      console.log("error while getting flight commission data", error);
    }
  };

  return (
    <>
      <div className="">
        <div className="sidemenu-show">
          <SideMenu />
        </div>

        <div className="wrapper flex grow flex-col">
          <Header />
        </div>
      </div>

      {/* flight-list-header */}
      <div className="flight-search-contain">
        <form className="flight-search-form">
          <div className="container-fluid">
            <div className="row ">
              <div className="col-lg-5 col-md-9 ">
                <div className="trip-type">
                  <MuiRadioButton
                    name="radio-options"
                    value={formik.values.tripType}
                    options={flightOptions}
                    onChange={(value) => {
                      formik.setFieldValue("tripType", value);
                      if (value === "One way") {
                        formik.setFieldValue("tripTypeNumber", 0);
                        formik.setFieldValue("toDate", "");
                      } else if (value === "Round Trip") {
                        formik.setFieldValue("tripTypeNumber", 1);
                      }
                    }}
                    direction="row"
                    isInvalid={false}
                    errorText="Please select an option"
                    isRequired={true}
                  />
                </div>
                <div
                  className="row d-flex justify-content-start"
                  style={{ position: "relative" }}
                >
                  <div className="col-md-5  col-sm-6 pe-n2">
                    <MuiSearchSelect
                      options={airportList}
                      placeholder="From"
                      onChange={(value, id, data) => {
                        setSwapOrigin(value);
                        setSwapOriginCode(data?.code);
                      }}
                      value={swapOrigin}
                    />
                  </div>
                  <div className="flight-header-icon col-md-1">
                    <div className="rder" onClick={handleSwap}>
                      <img
                        src="media/images/exchange.png"
                        alt="swap"
                        className={`transition-transform ${
                          rotated ? "rotate-180" : ""
                        }`}
                        style={{
                          transition: "transform 0.3s ease",
                          transform: rotated
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-5 col-sm-6 ps-n2">
                    <MuiSearchSelect
                      options={airportList}
                      placeholder="To"
                      onChange={(value, id, data) => {
                        setSwapDestination(value);
                        setSwapDestinationCode(data?.code);
                      }}
                      value={swapDestination}
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-2 col-md-3 c trip-one col-sm-6">
                <label className="py-2">Departure Date</label>
                <div>
                  <MuiDatePicker
                    value={
                      formik.values.fromDate
                        ? dayjs(formik.values.fromDate)
                        : null
                    }
                    onChange={(date: string) => {
                      formik.setFieldValue("fromDate", date);
                      formik.setFieldValue("toDate", "");
                    }}
                    isError={
                      formik.touched.fromDate && Boolean(formik.errors.fromDate)
                    }
                  />
                </div>
              </div>

              <div className="col-lg-2 col-md-3 col-sm-6">
                <label
                  className={`py-2 ${
                    formik.values.tripType === "One way"
                      ? "opacity-25 pe-none"
                      : ""
                  }`}
                >
                  Return Date
                </label>
                <div
                  className={`round-trip-error ${
                    formik.values.tripType === "One way"
                      ? "opacity-25 pe-none"
                      : ""
                  }`}
                >
                  <MuiDatePicker
                    placeholder="MM/DD/YYYY"
                    value={
                      formik.values.toDate ? dayjs(formik.values.toDate) : null
                    }
                    onChange={(date: string) => {
                      formik.setFieldValue("toDate", date);
                    }}
                    isError={
                      formik.touched.toDate && Boolean(formik.errors.toDate)
                    }
                    errorText={
                      formik.touched.toDate ? formik.errors.toDate : ""
                    }
                    // ✅ Set minDate from fromDate
                    minDate={
                      formik.values.fromDate
                        ? dayjs(formik.values.fromDate)
                        : undefined
                    }
                  />
                </div>
              </div>

              <div className="col-lg-2 col-md-3 col-sm-6">
                <label className="py-2">Travellers</label>
                <div>
                  <div className="dropdowns">
                    <MuiInput
                      placeholder="Enter Traveller(s), Class"
                      onClick={() => openPopup()}
                      onChange={(e: any) =>
                        formik.setFieldValue("travellersDetail", e)
                      }
                      value={formik.values.travellersDetail}
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-1 col-md-3 col-sm-6">
                <div className="flightlist-search-btn">
                  <MuiButton
                    label="Search"
                    variant="contained"
                    size="large"
                    onClick={() => {
                      formik.setFieldValue("origin", swapOrigin);
                      formik.setFieldValue("originCode", swapOriginCode);
                      formik.setFieldValue("destination", swapDestination);
                      formik.setFieldValue(
                        "destinationCode",
                        swapDestinationCode
                      );
                      const recentSearch = {
                        ...formik.values,
                        origin: swapOrigin,
                        originCode: swapOriginCode,
                        destination: swapDestination,
                        destinationCode: swapDestinationCode,
                      };
                      localStorage.setItem(
                        "flight_recent_search",
                        JSON.stringify(recentSearch)
                      );

                      formik.handleSubmit();
                    }}
                    className=" me-2 get-btn"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            {/* Traveller Dropdown */}
            {isPopupOpen && (
              <div className="traveller-box">
                <div className=" traveller-dropdown flight-list-traveller">
                  <div className="traveller-selection">
                    <div className="traveller-option">
                      <label>Adults </label>
                      <span>(12+ yrs)</span>
                      <select
                        value={formik.values.adults}
                        onChange={(e) =>
                          formik.setFieldValue("adults", Number(e.target.value))
                        }
                      >
                        {[...Array(10).keys()].map((num) => (
                          <option key={num + 1} value={num + 1}>
                            {num + 1}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="traveller-option">
                      <label>Children</label>
                      <span> (2-12 yrs)</span>
                      <select
                        value={formik.values.child}
                        onChange={(e) =>
                          formik.setFieldValue("child", Number(e.target.value))
                        }
                      >
                        {[...Array(5).keys()].map((num) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="traveller-option">
                      <label>Infants</label>
                      <span> (Below 2 yrs)</span>
                      <select
                        value={formik.values.infants}
                        onChange={(e) =>
                          formik.setFieldValue(
                            "infants",
                            Number(e.target.value)
                          )
                        }
                      >
                        {[...Array(3).keys()].map((num) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="class-selection">
                    {[
                      "Economy",
                      "Premium Economy",
                      "Business",
                      "First Class",
                    ].map((cls) => (
                      <label key={cls} className="radio-container">
                        <input
                          type="radio"
                          name="travelClass"
                          value={cls}
                          checked={formik.values.travelClass === cls}
                          onChange={handleRadioChange}
                        />
                        <span className="checkmark" /> {cls}
                      </label>
                    ))}
                  </div>
                  <button className="done-btn mt-3" onClick={handleDone}>
                    Done
                  </button>
                </div>
              </div>
            )}
          </div>
        </form>
      </div>

      <main className="grow content" id="content" role="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-3 margin-bottom-class">
              <FlightListFilterCard
                initialFilters={filters}
                airlines={extractAirlinesFromFlightData(originalFlightData)}
                origin={formik.values.origin}
                destination={formik.values.destination}
                onFilterChange={handleFilterChange}
              />
            </div>

            <div className="col-lg-9">
              {tripType === 0 && calenderMonthWiseData?.[0]?.length > 0 && (
                <div className="date-selector relative">
                  {/* Slider with Dates */}
                  <CalendarSlider
                    calenderMonthWiseData={calenderMonthWiseData}
                    formik={formik}
                  />
                  {/* Calendar Icon Fixed to Right */}
                  <div className="calendar-icon-container me-2">
                    <span onClick={() => setShowCalender(true)}>
                      <i className="fa fa-calendar calendar-icon" />
                    </span>
                  </div>
                  {/* Calendar Modal */}
                  {showCalender && (
                    <Modal
                      className="calender-bg"
                      open={showCalender}
                      onClose={() => setShowCalender(false)}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      <Box>
                        <Typography
                          id="modal-modal-description"
                          className="absolute calender-div"
                        >
                          <Calendar
                            calenderData={calenderData}
                            onDateSelect={(date) => {
                              formik.setFieldValue("fromDate", formatDate(date));
                              formik.handleSubmit();
                            }}
                            fromDate={formik.values.fromDate}
                          />
                        </Typography>
                      </Box>
                    </Modal>
                  )}
                </div>
              )}

              <FlightListMainCard
                cabin={formik.values.cabin}
                flightData={filteredFlightData}
                loading={loading}
                destination={formik.values.destination}
                origin={formik.values.origin}
                tripType={tripType}
                selectedDepartureDate={formik.values.fromDate}
                selectedReturnDate={formik.values.toDate}
                setSelectedDepartureDate={(date?: string) => {
                  formik.setFieldValue("fromDate", date);
                  formik.handleSubmit();
                }}
                setSelectedReturnDate={(date?: string) => {
                  formik.setFieldValue("toDate", date);
                  formik.handleSubmit();
                }}
                travellersDetail={travellersDetail}
                isInternationalFlight={isInternationalFlight}
                traceId={traceId}
              />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default FlightList;
